import React, { useState, useCallback } from "react";
import { Scrollbars } from "react-custom-scrollbars-2";
import { useDispatch, useSelector } from "react-redux";
import { subscribeToBot } from "../../../../state/actions/catalogue";
import { useNavigate } from "react-router-dom";
import { setSelectedBot } from "../../../../state/actions/domain";
import { clearSelectedConversation, createChatBotConversation, setSelectedOnetoOneChat } from "../../../../state/actions/chats";
import { getAuthData, isUserOnline, updateDataInStorage } from "../../../../services/storage/LocalStorage";
import { setHeaderTitle } from "../../../../state/actions/layout";

import CatalogBotsView from "../BotsView";
import BotModal from "../../botModal";
import { setBotWaitLoader, setBotWaitLoaderWithShimmer } from "../../../../state/actions/loader";
import { setCloseAssistantBot, setHideChatwidget, setHideDefaultHomepageBot } from "../../../../state/actions/bot";
import { resetTabStack, setTabState } from "../../../../state/actions/tabStack";
import { withOutInitSocket } from "../../../../state/actions/socket";
import { LFStorageKeys } from "../../../../services/storage/LFStorage";


const CatalogSide = ({ botSubscriptions, createConversation, userId }) => {
	const [botToView, setBotToView] = useState(null);
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const authData = getAuthData();
	const user = authData?.user || null;

	const selectedDomain = useSelector((state) => state.domain.selectedDomain);

	const createConv = useCallback(async (bot) => {
		if (isUserOnline()) {
			let convBot = botSubscriptions.find((item) => item.botId === bot?.botId);
			if (!convBot) return;
			if (convBot && Object.keys(convBot).length > 0) {
				if (!convBot.customFrontEnd) {
					dispatch(createChatBotConversation(convBot, user?.userId));
				}
				dispatch(setHeaderTitle(convBot?.botName));
				dispatch(setSelectedBot(convBot));
				updateDataInStorage(LFStorageKeys.SELECTED_BOT, JSON.stringify(convBot));
				dispatch(setBotWaitLoader(true));
				dispatch(setBotWaitLoaderWithShimmer(true));
				dispatch(clearSelectedConversation());
					if (!convBot.conversational) {
					  dispatch(setSelectedOnetoOneChat(false))
					}
					dispatch(setHideDefaultHomepageBot());
					dispatch(setTabState(true));
				    dispatch(withOutInitSocket(true))
					updateDataInStorage(LFStorageKeys.HEADER_TITLE, convBot?.botName);
					const activeItemValue = `App Marketplace-${convBot?.botName}`;
					// Save all relevant data for persistence
					updateDataInStorage(LFStorageKeys.ACTIVE_ITEM, activeItemValue);
					  window.document.title = convBot?.botName;
					dispatch(resetTabStack());
					dispatch(setCloseAssistantBot());
					dispatch(setHideChatwidget(true));
					navigate("/app/chats");
			} else;
		}

	}, [botSubscriptions, createConversation, dispatch, selectedDomain, userId]);


	const openBot = (bot) => setBotToView(bot);
	const closeBot = () => setBotToView(null);

	const botList = (botSubscriptions || []).filter((elem) => !elem.systemBot && elem.botClients?.web !== false);

	return (
		<div className="Catalog-sidebar sidebar-sm p-2 catalog-right" id="sidebar-collapse">
			<h4 className={`d-block mb-1 px-2 color-[#4A4A4A] text-size-18`}>
				Installed apps
			</h4>
			<Scrollbars autoHide style={{ height: "calc(100vh - 100px - 60px)" }}>
				<div className="Catalog-messages px-3 mt-2">
					<CatalogBotsView
						bots={botList.map((bs) => ({ ...bs, subscribed: true }))}
						subscribeToBot={(bot) => dispatch(subscribeToBot(bot))}
						botHolderStyle={{
							marginBottom: "10px",
							borderRadius: "10px",
							boxShadow: "rgba(0, 0, 0, 0.2) 0px 0px 6px ",
						}}
						createConversation={createConv}
						openBot={openBot}
						userDomain={selectedDomain}
						catalogSide={true}
					/>
				</div>
			</Scrollbars>
			{botToView && (
				<BotModal
					bot={botToView}
					close={closeBot}
					subscribeToBot={(bot) => dispatch(subscribeToBot(bot))}
					createConversation={createConv}
				/>
			)}
		</div>
	);
};

export default CatalogSide;
